<template>
  <div class="d-flex">
    <v-menu
      v-model="menuOpen"
      :close-on-content-click="true"
      min-width="280"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          icon
          outlined
          v-bind="attrs"
          @click="menuOpen = !menuOpen"
          v-on="on"
        >
          <v-icon>history</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="pb-2">
          <v-icon class="mr-2" color="primary">history</v-icon>
          Seleccionar Versión
        </v-card-title>
        <v-divider></v-divider>
        <v-list class="py-0" max-height="300" style="overflow-y: auto;">
          <v-list-item
            v-for="version in versions"
            :key="version.version"
            :class="{ 'version-selected': versionSelected && version.version === versionSelected.version }"
            class="version-item"
            @click="selectVersion(version)"
          >
            <v-list-item-icon class="mr-3">
              <v-icon :color="getVersionStatusColor(version.status)">
                {{ getVersionIcon(version.status) }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                Versión {{ version.version }}
              </v-list-item-title>
              <v-list-item-subtitle class="caption">
                {{ $moment.unix(version.creation_timestamp).fromNow() }} •
                {{ getStatusInfo(version.status).name }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="versionSelected && version.version === versionSelected.version">
              <v-icon color="primary" small>check</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider v-if="versions.length === 0"></v-divider>
          <v-list-item v-if="versions.length === 0" class="text-center">
            <v-list-item-content>
              <v-list-item-title class="grey--text">
                Sin versiones disponibles
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-btn
      v-if="showAddButton"
      class="ml-2"
      color="primary"
      max-width="36px"
      min-width="36px"
      width="36px"
      @click="$emit('create-new-version')"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import model_checklist from '@/constants/models/pkc/model_checklist'

  export default {
    name: 'ChecklistVersionSelector',
    props: {
      versions: {
        type: Array,
        required: true
      },
      versionSelected: {
        type: Object,
        default: null
      },
      showAddButton: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        menuOpen: false,
        modelData: model_checklist
      }
    },
    methods: {
      selectVersion(version) {
        this.$emit('version-selected', version)
        this.menuOpen = false
      },
      getVersionIcon(status) {
        const statusIcons = {
          'draft': 'edit',
          'pending': 'hourglass_empty',
          'in_review': 'rate_review',
          'approved': 'check_circle',
          'completed': 'done_all',
          'rejected': 'cancel'
        }
        return statusIcons[status] || 'assignment'
      },
      getVersionStatusColor(status) {
        const statusColors = {
          'draft': 'warning',
          'pending': 'info',
          'in_review': 'primary',
          'approved': 'success',
          'completed': 'success',
          'rejected': 'error'
        }
        return statusColors[status] || 'grey'
      },
      getStatusInfo(status) {
        return this.modelData.statuses.find(s => s.id === status)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/resources/colors.scss";

  .version-item {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }

    &.version-selected {
      background-color: rgba(25, 118, 210, 0.1);

      .v-list-item-title {
        color: #1976d2;
        font-weight: bold !important;
      }
    }
  }
</style>
